<template>
  <div class="file-manager-main-content" @click="clearSelect()">
    <!-- search area start -->
    <div class="file-manager-content-header d-flex justify-content-between align-items-center">
      <SearchContents />
      <div class="display-flex">
        <ActionMenu />
        <AddNew />
        <span style="margin-left: 32px" />
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon d-sm-none d-xl-inline"
          :class="{ active: showDetails }"
          @click="onChangeShowDetails(!showDetails)"
        >
          <feather-icon icon="InfoIcon" />
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon"
          :class="{ active: !showListView }"
          @click="onChangeShowListView(false)"
        >
          <feather-icon icon="GridIcon" />
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="btn-icon"
          :class="{ active: showListView }"
          @click="onChangeShowListView(true)"
        >
          <feather-icon icon="ListIcon" />
        </b-button>
      </div>
    </div>
    <!-- search area ends here -->

    <div v-if="organisations" class="file-manager-content-body d-flex">
      <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="user-chats view-container-wrap">
        <Loading :visible="organisationsLoading">
          <div ref="clickWrap">
            <!-- Folders Container Starts -->
            <div class="view-container" :class="{ 'list-view': showListView }">
              <h6 v-if="organisations" class="files-section-title mt-25 mb-75">Organisations</h6>
              <div v-if="organisations && organisations.length === 0" class="card file-manager-item folder level-up">
                <div class="card-img-top file-logo-wrapper">
                  <div class="d-flex align-items-center justify-content-center w-100">
                    <i data-feather="arrow-up" />
                  </div>
                </div>
                <div class="card-body pl-2 pt-0 pb-1">
                  <div class="content-wrapper">
                    <p class="card-text file-name mb-0">...</p>
                  </div>
                </div>
              </div>
              <Organisation v-if="showListView"  />
              <Organisation
                v-for="organisation in organisations"
                :key="organisation.id"
                :organisation="organisation"
                :show-list-view="showListView"
                :class="showListView ? 'col-md-12 clear-padding' : 'col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxl-2'"
              ></Organisation>
            </div>
            <div v-if="organisations && organisations.length === 0" class="no-content">
              <div>
                <p>No organisations found</p>
              </div>
            </div>
            <div class="view-container" :class="{ 'list-view': showListView }">
              <h6 v-if="users && users.length !== 0" class="files-section-title mt-2 mb-75">Users</h6>
              <User
                v-for="user in users"
                :key="user.id"
                :user="user"
                :show-list-view="showListView"
                :class="showListView ? 'col-md-12 clear-padding' : 'col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-3 col-xxl-2'"
              />
            </div>
          </div>
        </Loading>
      </vue-perfect-scrollbar>

      <vue-perfect-scrollbar v-if="showDetails" :settings="perfectScrollbarSettings" class="user-chats file-info-container">
        <div>
          <OrganisationDetailsModal v-if="showOrganisationDetails" />
          <div v-else class="no-preview text-muted d-none d-xl-block">
            <div class="no-preview-message">
              <feather-icon icon="EyeOffIcon" size="48" />
              <h6 class="text-muted">There is nothing to preview.</h6>
            </div>
          </div>
        </div>
      </vue-perfect-scrollbar>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
// import { getList as getTableList } from '@/api/oragnisation'
import ActionMenu from './components/ActionMenu.vue'
import { VBToggle, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Organisation from '@/components/Organisation.vue'
import User from '@/components/User.vue'
import SearchContents from '@/components/SearchContents'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import OrganisationDetailsModal from '@/components/OrganisationDetailsModal.vue'
import Loading from '@/components/Loading'
import AddNew from '@/components/add/AddNew'

export default {
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  components: {
    AddNew,
    Loading,
    BButton,
    ActionMenu,
    Organisation,
    User,
    VuePerfectScrollbar,
    SearchContents,
    OrganisationDetailsModal
  },
  data() {
    return {
      showListView: false,
      searchText: null,
      showDetails: true,
      perfectScrollbarSettings: {
        maxScrollbarLength: 150
      }
    }
  },
  computed: {
    ...mapState('home', ['organisations', 'users', 'organisationsLoading']),
    ...mapState('organisationDetailsModal', ['organisation', 'showDeleteModal']),
    ...mapState('userDetailsModal', ['user', 'showDeleteModal']),
    showOrganisationDetails: {
      get() {
        return this.$store.state.organisationDetailsModal.showModal
      },
      set(value) {
        this.$store.dispatch('organisationDetailsModal/onChangeModal', { visible: value })
      }
    }
  },
  mounted: async function () {
    this.$store.dispatch('home/getOrganisations', {
      self: this
    })
  },
  methods: {
    clearSelect() {
      this.$store.commit('home/CLEAR_SELECT_ENTITIES', this.organisation)
    },
    onChangeShowListView(value) {
      this.showListView = value
    },
    onChangeShowDetails(value) {
      this.showDetails = value
      if (this.showDetails === false) {
        this.showOrganisationDetails = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_variables';
@keyframes loading {
  to {
    background-position: 350% 0, var(--title-position), var(--desc-line-1-position), var(--desc-line-2-position), var(--avatar-position),
      var(--footer-position), 0 0 !important;
  }
}

.content-area-wrapper {
  height: calc(var(--vh, 1vh) * 100 - calc(calc(2rem * 1) + 4.45rem + 3.35rem + 0.3rem)) !important;
}

.vault-label {
  margin-left: 15px;
}

.files-header {
  margin-left: 0px !important;
  margin-bottom: 0px !important;
}

.folder-icon {
  stroke: $purple !important;
}

.dark-layout .folder-icon {
  stroke: $dark-layout-purple !important;
}

.no-content {
  text-align: center;
  width: auto;
  height: auto;
  position: relative;
}

.btn-icon {
  border: none !important;
  padding: 0 !important;
  margin: 1px !important;
  color: $purple !important;
  background: transparent !important;
}

.btn-icon:hover {
  background: $purple !important;
  color: white !important;
}

.btn-icon svg {
  width: 1.5em !important;
  height: 1.5em !important;
  margin: 0.8em !important;
}

.active {
  background: $purple !important;
  color: white !important;
  opacity: 0.8;
}

.file-manager-item {
  &:hover {
    border-radius: 8px;
    background: #f4f5f6;
  }
}

.clear-padding {
  padding: 0;
}

.file-manager-content-body {
  // overflow: auto;
  overflow: hidden;
  padding-right: 0 !important;
  @media (max-width: 576px) {
    padding: 0.5rem !important;
  }

  .view-container-wrap {
    flex: 1;
    // padding-right: 2rem;
    width: 100%;
  }

  .file-info-container {
    flex: 0 0 250px;
    // padding-left: 20px;
    // overflow: auto;

    @media (max-width: 1200px) {
      flex: 0 !important;
      padding-left: 0 !important;
    }
  }
}

.files-section-title {
  color: $purple;
  font-weight: 500;
}

.display-flex {
  display: flex;
}

.display-inline {
  display: inline;
  color: $purple;
  margin-right: 1rem;
}

.text-muted {
  color: $text-muted;
}

.no-preview {
  text-align: center;
  display: flex;
  align-items: center;
  position: absolute;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  padding-left: 2rem;
}

.no-preview-message {
  margin: 0 auto;
}

.file-item-size {
  margin-right: 3.5rem !important;
}

.file-item-modified {
  margin-right: 8.5rem;
}

.border-dotted {
  border-style: dashed;
  border-color: $purple;
  border-radius: 0.5rem;
  padding: 5rem;
}

.border-dotted .feather {
  color: $purple;
}
</style>
